angular.module('app').controller('OrderCtrl', function($scope, $controller, $http, $mdDialog, PhotoUtils, appUtils, $mdToast) {
    "ngInject";
    var main = this;

    main.name = 'orders';
    main.calculated = {};
    main.defaults = {
        'cart_total': 0,
        'discount': 0,
        'total': 0,
        'tax': 0,
        'shipping': 0,
        'status': 'pending',
        'subjects': [],
        'payments': [],
        'billing_address': {},
        'shipping_address': {},
        'line_items': []
    };
    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));
    main.photoUtils = PhotoUtils;

    main.removeLineItem = function(li) {
        if(li.id) {
            if(confirm('Are you sure you want to delete this line item')) {
                $http.put('/api/v1/admin/line_item/' + li.id, {'order_id': null}).then(
                    function(response) {
                        appUtils.remove(li, null, main.item.line_items);
                        main.calculateTotals();
                    }
                );
            }
        } else {
            appUtils.remove(li, null, main.item.line_items);
            main.calculateTotals();
        }
    };

    main.eventSearch = function() {
        var params = appUtils.emptyQuery();
        params.searchSchools = $scope.searchText3;

        return appUtils.search('event', $scope.searchText3, params);
    };

    main.resendReceipt = function() {
        $http.post('/api/v1/admin/orders/' + main.item.id + '/resend-receipt').then(
            function(response) {
                var alert = $mdToast.simple().textContent("Receipt sent");
                $mdToast.show(alert);
            }
        );
    };

    main.updateEvent = function() {
        main.item.event_id = main.item.event.id;
        if(!main.item.event.price_list_id) {
            main.priceList = null;
            return;
        }
        $http({
            'method': 'GET',
            'url': '/api/v1/admin/price_list/' + main.item.event.price_list_id
        }).then(
            function(response) {
                main.item.price_list = response.data;
            },
            function() {
                main.priceList = null;
            }
        );
    };

    main.buildNewLineItem = function() {
        var options = {};
        if(main.productToAdd.product.buy_all) {
            options.galleries = main.item.subjects.map(function(s) { return s.id; });
        }

        return {
            'quantity': 1,
            'item_id': main.productToAdd.id,
            'options': options,
            'sub_line_items': [],
            'name': main.productToAdd.product.name,
            'item': {
                'product_id': main.productToAdd.product.id,
                'name': main.productToAdd.product.name,
                'type': main.productToAdd.product.type,
            }
        };
    };

    main.editCustomLineItem = function(li) {
        return $mdDialog.show({
            'controller': 'CustomLineItemCtrl',
            'controllerAs': 'main',
            'templateUrl': 'custom-line-item.html',
            'multiple': false,
            'locals': {
                'order': main.item,
                'line_item': li
            }
        });
    };

    main.addLineItem = function() {
        if(main.productToAdd == null) {
            return;
        }

        if(main.productToAdd == 'custom') {
            main.editCustomLineItem({}).then(
                function(li) {
                    main.item.line_items.push(li);
                }
            );
            return;
        }

        var li = main.buildNewLineItem();
        if(main.productToAdd.product.type == 'package') {
            $http.get('/api/v1/admin/product/' + main.productToAdd.product.id).then(
                function(response) {
                    response.data.fixed_product_relationships.forEach(function(fp) {
                        li.sub_line_items.push({
                            'product_id': fp.product.id,
                            'options': {},
                            'item': fp.product
                        });
                    });

                    for(var i=0; i<response.data.units; i++) {
                        li.sub_line_items.push({'options': {}});
                    }

                    main.item.line_items.push(li);
                    main.calculateTotals();
                }
            );
        } else {
            main.item.line_items.push(li);
            main.editLineItemPhoto(li);
            main.calculateTotals();
        }

        main.productToAdd = null;
    };

    main.photoParams = function() {
        return {
            'method': 'GET',
            'url': '/api/v1/admin/orders/available-photos',
            'params': {
                'event_id': main.item.event_id,
                'event_signup_id': main.item.subjects.map(function(sub) {
                    return sub.id;
                })
            }
        }
    }

    main.subjectSearch = function(searchText) {
        return appUtils.orSearch(
            'event_signup',
            ['first_name', 'last_name'],
            searchText,
            {
                'q': {
                    'filters': [
                        {
                            'name': 'event_id',
                            'op': 'eq',
                            'val': main.item.event_id
                        }
                    ]
                }
            }
        );
    }

    main.editLineItemPhoto = function(lineItem) {
        var req = main.photoParams();
        main.editPhoto(null, lineItem, 'LineItemCtrl');
    };

    main.editPhoto = function(subLineItem, lineItem, ctrl) {

        if(!ctrl) {
            ctrl = 'SubLineItemCtrl';
        }

        var req = main.photoParams();
        var photos = $http(req).then(
            function(results) {
                $mdDialog.show({
                    'controller': ctrl,
                    'controllerAs': 'main',
                    'templateUrl': 'photo-picker.html',
                    'multiple': false,
                    'locals': {
                        'order': main.item,
                        'photos': results.data.objects,
                        'subLineItem': subLineItem,
                        'lineItem': lineItem
                    }
                });
            }
        );
    };

    main.updateTotal = function() {
        main.item.total = main.item.cart_total - main.item.discount + main.item.tax + main.item.shipping;
        main.item.balance_due = main.item.payments.reduce(function(total, p) {
            return total - p.total;
        }, main.item.total);
    };
    main.calculateTotals = function() {
        if(main.id != 'new') {
            main.updateTotal();
            return;
        }

        $http.post('/api/v1/admin/orders/calculate-total', main.item).then(
            function(response) {
                main.calculated = response.data;
                main.updateTotal();
                if(main.id == 'new') {
                    Object.assign(main.item, response.data);
                }
            }
        );
    }

    main.editLineItem = function(lineItem, subLineItem, ctrl, template) {
        if(!ctrl) {
            ctrl = 'LineItemCtrl'
        }

        if(!template) {
            template = 'lineitem.html';
        }

        $mdDialog.show({
            'controller': ctrl,
            'controllerAs': 'main',
            'templateUrl': template,
            'multiple': true,
            'clickOutsideToClose': true,
            'locals': {
                'photos': [],
                'order': main.item,
                'subLineItem': subLineItem,
                'lineItem': lineItem
            }
        }).then(main.calculateTotals);
    };

    main.editSubLineItem = function(subLineItem, lineItem) {
        main.editLineItem(lineItem, subLineItem, 'SubLineItemCtrl', 'sublineitem.html');
    };

    main.refund = function(payment) {
        if(['Credit Card', 'paypal', 'venmo'].includes(payment.type)) {
            $mdDialog.show({
                'controller': 'RefundCtrl',
                'controllerAs': 'main',
                'templateUrl': 'refund.html',
                'multiple': true,
                'clickOutsideToClose': true,
                'locals': {
                    'order': main.item,
                    'payment': payment
                }
            })
        } else {
            $http.delete('/api/v1/admin/payment/' + payment.id).then(
                function() {
                    appUtils.remove(payment, 'id', main.item.payments);
                }
            );
        }
    }

    main.save = function() {
        if(main.id == 'new') {
            return main._save();
        };

        var newLineItems = main.item.line_items.filter(function(li) {
            return !li.id;
        });

        if(newLineItems.length == 0) {
            return main._save();
        }

        $http.post('/api/v1/admin/orders/' + main.item.id + "/line_item", newLineItems).then(
            function() {
                main._save();
            }
        );
    }
});
